import { CircularProgress } from "@mui/material"
import PropTypes from 'prop-types'
import { ErrorWithBackButton, ErrorWithoutBackButton } from "./ErrorMessages"

export const Loader = ({message}) => {
    return (
        <>
            <CircularProgress thickness={2}/>
            <br />
            <p className='sm-text grey-text'>{message}</p>
        </>
    )
}

export const LoaderOverlay = ({hasError , message}) => {
    return (
      <div className='loader'>
        {
          hasError 
            ? <ErrorWithBackButton message={message} handleAction={window.location.reload()}/> 
            : <Loader message={message}/>
        }
      </div>
    )
  }

export const LoaderViewer = ({hasError, handleReload}) => {
    return (
        <div className='loader__viewer'>
        { 
            hasError 
            ? <ErrorWithoutBackButton 
                message={'Error al cargar el visor'} 
                handleAction={handleReload}/>
            : <Loader message={'Cargando visor'}/>
        }
        </div>
    )
}
  
LoaderViewer.propTypes = {
    hasError: PropTypes.bool,
    handleReload: PropTypes.func,
    message: PropTypes.string,
}
  
  
LoaderOverlay.propTypes = {
    hasError: PropTypes.bool,
    message: PropTypes.string,
}
  

Loader.propTypes = {
    message: PropTypes.string,
}